import { UserInfo } from '../request/User';

export enum UserType {
  User = 'USER',
  CompanyHolder = 'COMPANY_HOLDER',
  NomineeCompanyHolder = 'NOMINEE_COMPANY_HOLDER',
  NomineeAgent = 'NOMINEE_AGENT',
}

export interface User extends UserInfo {
  id: number;
  email: string;
  avatar?: string;
  nomineeFlowAllowed: boolean;
  userType: UserType;
  emailVerified: boolean;
  currency: string;

  investorQualificationStage: InvestorQualificationStage;
  kycVerificationStage?: KYCVerificationStatus;
  completedQuestionnaire: boolean;
  personalDetailsLocked: boolean;

  passwordLastChangedAt: Date;
}

export enum InvestorQualificationStage {
  AwaitingQuestionnaire = 'AWAITING_QUESTIONNAIRE',
  QuestionnaireSubmitted = 'QUESTIONNAIRE_SUBMITTED',
  CompletedQualified = 'COMPLETED_QUALIFIED',
  CompletedNotQualified = 'COMPLETED_NOT_QUALIFIED',
}

export enum KYCVerificationStatus {
  NotStarted = 'NOT_STARTED',
  ThirdPartyChecksInitiated = 'THIRD_PARTY_CHECKS_INITIATED',
  ThirdPartyChecksCompletedVerified = 'THIRD_PARTY_CHECKS_COMPLETED_VERIFIED',
  ThirdPartyChecksCompletedVerifiedRejected = 'THIRD_PARTY_CHECKS_COMPLETED_REJECTED',
  CompletedVerified = 'COMPLETED_VERIFIED',
  CompletedRejected = 'COMPLETED_REJECTED',
}

export interface UserSuccess {
  msg: string;
}

export interface UserLoginResponse {
  sessionId: string;
  qr: string;
}

export interface UserBasicTokenResponse {
  accessToken: string;
  lastLogin: string;
  userId: string;
}

export interface UserMarketPreferencesResponse {
  emailAlerts: boolean;
  emails: boolean;
  textAlerts: boolean;
}

export enum AccessAppRecordStatusEnum {
  RECORD_NOT_FOUND = 'RECORD_NOT_FOUND',
  READY = 'READY',
  INITIALIZED = 'INITIALIZED',
  LOGIN_PENDING = 'LOGIN_PENDING',
  LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL',
  LOGIN_ERROR = 'LOGIN_ERROR',
  ACCOUNT_DISABLED = 'ACCOUNT_DISABLED',
}

export enum WebsocketSignInResponseStatusEnum {
  USER_CREATED = 'USER_CREATED',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
